/* !!! This is code generated by Prisma. Do not edit directly. !!! */ /* eslint-disable */ // biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */ import * as runtime from "@prisma/client/runtime/index-browser";
export const Decimal = runtime.Decimal;
export const NullTypes = {
    DbNull: runtime.NullTypes.DbNull,
    JsonNull: runtime.NullTypes.JsonNull,
    AnyNull: runtime.NullTypes.AnyNull
};
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */ export const DbNull = runtime.DbNull;
/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */ export const JsonNull = runtime.JsonNull;
/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */ export const AnyNull = runtime.AnyNull;
export const ModelName = {
    User: 'User',
    UserMarketingMetadata: 'UserMarketingMetadata',
    BotUser: 'BotUser',
    Session: 'Session',
    Token: 'Token',
    MembershipToken: 'MembershipToken',
    Organization: 'Organization',
    OrganizationSubscription: 'OrganizationSubscription',
    LocalizationProvider: 'LocalizationProvider',
    LocalizationProviderSync: 'LocalizationProviderSync',
    LocalizationProviderFilePath: 'LocalizationProviderFilePath',
    LocalizationProviderKeyName: 'LocalizationProviderKeyName',
    SWLocalization_Project: 'SWLocalization_Project',
    SWLocalization_ProjectLanguage: 'SWLocalization_ProjectLanguage',
    SWLocalization_Key: 'SWLocalization_Key',
    SWLocalization_KeyTranslation: 'SWLocalization_KeyTranslation',
    SuperwallLocalizationProvider: 'SuperwallLocalizationProvider',
    OrganizationUsageRecord: 'OrganizationUsageRecord',
    ApplicationMarketingMetadata: 'ApplicationMarketingMetadata',
    ApplicationAnalyticsMetadata: 'ApplicationAnalyticsMetadata',
    ApplicationUseageRecord: 'ApplicationUseageRecord',
    OrganizationLocalizationTarget: 'OrganizationLocalizationTarget',
    Membership: 'Membership',
    Application: 'Application',
    Project: 'Project',
    ProjectApplication: 'ProjectApplication',
    GloballyEnabledFeature: 'GloballyEnabledFeature',
    ApplicationAuthenticationToken: 'ApplicationAuthenticationToken',
    IntegrationAuthenticationToken: 'IntegrationAuthenticationToken',
    ApplicationAsaConfiguration: 'ApplicationAsaConfiguration',
    ApplicationAssConfiguration: 'ApplicationAssConfiguration',
    ApplicationAscConfiguration: 'ApplicationAscConfiguration',
    ApplicationGPAuthConfiguration: 'ApplicationGPAuthConfiguration',
    ApplicationLiveStripeConfiguration: 'ApplicationLiveStripeConfiguration',
    ApplicationTestStripeConfiguration: 'ApplicationTestStripeConfiguration',
    PaddleOAuthState: 'PaddleOAuthState',
    ApplicationLivePaddleOAuthConfiguration: 'ApplicationLivePaddleOAuthConfiguration',
    ApplicationTestPaddleOAuthConfiguration: 'ApplicationTestPaddleOAuthConfiguration',
    ApplicationSetting: 'ApplicationSetting',
    ApplicationWebhookDestination: 'ApplicationWebhookDestination',
    ApplicationUserAttributeMapping: 'ApplicationUserAttributeMapping',
    ApplicationConfigCache: 'ApplicationConfigCache',
    ShortLink: 'ShortLink',
    Paywall: 'Paywall',
    PaywallResourceRequirement: 'PaywallResourceRequirement',
    PaywallVersion: 'PaywallVersion',
    PaywallSnapshot: 'PaywallSnapshot',
    PaywallResourcePaywallVersionRequirement: 'PaywallResourcePaywallVersionRequirement',
    PaywallResourcePaywallVersionVarintFixture: 'PaywallResourcePaywallVersionVarintFixture',
    PaywallResource: 'PaywallResource',
    TextPaywallResourceVersionRequirement: 'TextPaywallResourceVersionRequirement',
    TextPaywallResourceVersionVariantRequirement: 'TextPaywallResourceVersionVariantRequirement',
    PaywallLanguageRequirement: 'PaywallLanguageRequirement',
    TextPaywallResource: 'TextPaywallResource',
    TextPaywallResourceVersion: 'TextPaywallResourceVersion',
    TextPaywallResourceVersionVariant: 'TextPaywallResourceVersionVariant',
    TextPaywallResourceVersionVariantVersion: 'TextPaywallResourceVersionVariantVersion',
    PaywallResourceVersion: 'PaywallResourceVersion',
    PaywallResourceVersionVariant: 'PaywallResourceVersionVariant',
    PaywallSurvey: 'PaywallSurvey',
    PaywallPreview: 'PaywallPreview',
    PaywallLocalization: 'PaywallLocalization',
    LocalizableString: 'LocalizableString',
    PaywallLocalizableStringRequirement: 'PaywallLocalizableStringRequirement',
    LocalizedString: 'LocalizedString',
    PaywallTrigger: 'PaywallTrigger',
    WebPaywallTrigger: 'WebPaywallTrigger',
    WebPaywall: 'WebPaywall',
    WebProduct: 'WebProduct',
    StripeProductRanking: 'StripeProductRanking',
    TriggerExperimentGroup: 'TriggerExperimentGroup',
    ApplicationUser: 'ApplicationUser',
    ApplicationUserNotificationV2Assigment: 'ApplicationUserNotificationV2Assigment',
    ApplicationUserAlias: 'ApplicationUserAlias',
    ApplicationUserEvent: 'ApplicationUserEvent',
    CustomerDomain: 'CustomerDomain',
    StandardEvent: 'StandardEvent',
    StorageBlob: 'StorageBlob',
    LocalizationFileUpload: 'LocalizationFileUpload',
    NotificationTimeline: 'NotificationTimeline',
    NotificationTimelineV2: 'NotificationTimelineV2',
    NotificationNodeV2: 'NotificationNodeV2',
    NotificationNode: 'NotificationNode',
    NotificationPlan: 'NotificationPlan',
    Product: 'Product',
    ProductEntitlements: 'ProductEntitlements',
    Entitlement: 'Entitlement',
    LocalizedProduct: 'LocalizedProduct',
    TriggerExperiment: 'TriggerExperiment',
    Experiment: 'Experiment',
    Variant: 'Variant',
    Assignment: 'Assignment',
    PaywallAsset: 'PaywallAsset',
    ApplicationETLDestination: 'ApplicationETLDestination',
    SDKConfigurationToggle: 'SDKConfigurationToggle',
    ApplicationSettings: 'ApplicationSettings',
    ChatOpsSettings: 'ChatOpsSettings',
    PaywallTemplate: 'PaywallTemplate',
    Survey: 'Survey',
    StaffBarKV: 'StaffBarKV',
    StorefrontCurrencyPriceInfo: 'StorefrontCurrencyPriceInfo',
    CurrencyExchangeRate: 'CurrencyExchangeRate',
    SubscriptionEvent: 'SubscriptionEvent',
    OAuth2AuthorizationCode: 'OAuth2AuthorizationCode',
    OAuth2AccessToken: 'OAuth2AccessToken',
    WebPaywallDomain: 'WebPaywallDomain',
    AccountsAccount: 'AccountsAccount',
    AccountsJwks: 'AccountsJwks',
    AccountsOauthAccessToken: 'AccountsOauthAccessToken',
    AccountsOauthApplication: 'AccountsOauthApplication',
    AccountsOauthConsent: 'AccountsOauthConsent',
    AccountsPasskey: 'AccountsPasskey',
    AccountsSession: 'AccountsSession',
    AccountsTwoFactor: 'AccountsTwoFactor',
    AccountsVerification: 'AccountsVerification',
    ApplicationIntegrationMetadata: 'ApplicationIntegrationMetadata',
    UserView: 'UserView',
    Web2AppIntegration: 'Web2AppIntegration',
    IntegrationAccessRequest: 'IntegrationAccessRequest',
    FigmaExportUpload: 'FigmaExportUpload'
};
/*
 * Enums
 */ export const TransactionIsolationLevel = {
    ReadUncommitted: 'ReadUncommitted',
    ReadCommitted: 'ReadCommitted',
    RepeatableRead: 'RepeatableRead',
    Serializable: 'Serializable'
};
export const UserScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    name: 'name',
    email: 'email',
    hashedPassword: 'hashedPassword',
    role: 'role',
    isBotUser: 'isBotUser',
    image: 'image',
    twoFactorEnabled: 'twoFactorEnabled',
    emailVerified: 'emailVerified',
    crmMetadata: 'crmMetadata'
};
export const RelationLoadStrategy = {
    query: 'query',
    join: 'join'
};
export const UserMarketingMetadataScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    metadata: 'metadata',
    userId: 'userId'
};
export const BotUserScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    name: 'name',
    userId: 'userId',
    authorizedSOAs: 'authorizedSOAs',
    accessToken: 'accessToken'
};
export const SessionScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    expiresAt: 'expiresAt',
    handle: 'handle',
    hashedSessionToken: 'hashedSessionToken',
    antiCSRFToken: 'antiCSRFToken',
    publicData: 'publicData',
    privateData: 'privateData',
    userId: 'userId'
};
export const TokenScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    hashedToken: 'hashedToken',
    type: 'type',
    expiresAt: 'expiresAt',
    sentTo: 'sentTo',
    userId: 'userId'
};
export const MembershipTokenScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    hashedToken: 'hashedToken',
    type: 'type',
    expiresAt: 'expiresAt',
    sentTo: 'sentTo',
    membershipId: 'membershipId',
    inviterId: 'inviterId'
};
export const OrganizationScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    name: 'name',
    hasOrderedIntegrationGift: 'hasOrderedIntegrationGift',
    stripeCustomer: 'stripeCustomer',
    stripeSubscription: 'stripeSubscription',
    lastUsageReportDate: 'lastUsageReportDate',
    trialEndDate: 'trialEndDate',
    billingType: 'billingType',
    localizationIntegration: 'localizationIntegration',
    crmMetadata: 'crmMetadata'
};
export const OrganizationSubscriptionScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    organizationId: 'organizationId',
    stripeSubscriptionId: 'stripeSubscriptionId',
    stripeCustomerId: 'stripeCustomerId',
    stripePriceIds: 'stripePriceIds',
    status: 'status',
    currentPeriodStart: 'currentPeriodStart',
    currentPeriodEnd: 'currentPeriodEnd',
    cancelAtPeriodEnd: 'cancelAtPeriodEnd',
    canceledAt: 'canceledAt',
    trialStart: 'trialStart',
    trialEnd: 'trialEnd',
    lastEventTimestamp: 'lastEventTimestamp'
};
export const LocalizationProviderScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    subtypeMigrationVersion: 'subtypeMigrationVersion',
    type: 'type',
    projectIdentifier: 'projectIdentifier',
    projectDisplayName: 'projectDisplayName',
    props: 'props',
    sourceLanguageLocale: 'sourceLanguageLocale',
    sourceLanguageDisplayName: 'sourceLanguageDisplayName',
    sourceLanguageProviderLanguageId: 'sourceLanguageProviderLanguageId',
    sourceLanguageIsRTL: 'sourceLanguageIsRTL',
    visibilitySince: 'visibilitySince',
    meta: 'meta',
    organizationId: 'organizationId'
};
export const LocalizationProviderSyncScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    endedAt: 'endedAt',
    succeeded: 'succeeded',
    message: 'message',
    keyCount: 'keyCount',
    updatedKeyCount: 'updatedKeyCount',
    localizationProviderId: 'localizationProviderId'
};
export const LocalizationProviderFilePathScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    fileId: 'fileId',
    filePath: 'filePath',
    localizationProviderId: 'localizationProviderId'
};
export const LocalizationProviderKeyNameScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    keyId: 'keyId',
    fileId: 'fileId',
    keyName: 'keyName',
    localizationProviderId: 'localizationProviderId'
};
export const SWLocalization_ProjectScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    projectIdentifier: 'projectIdentifier',
    organizationId: 'organizationId'
};
export const SWLocalization_ProjectLanguageScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    locale: 'locale',
    projectIdentifier: 'projectIdentifier',
    organizationId: 'organizationId'
};
export const SWLocalization_KeyScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    key: 'key',
    baseText: 'baseText',
    projectIdentifier: 'projectIdentifier',
    organizationId: 'organizationId'
};
export const SWLocalization_KeyTranslationScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    translation: 'translation',
    keyId: 'keyId',
    locale: 'locale',
    projectIdentifier: 'projectIdentifier',
    organizationId: 'organizationId'
};
export const SuperwallLocalizationProviderScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    projectIdentifier: 'projectIdentifier',
    organizationId: 'organizationId'
};
export const OrganizationUsageRecordScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    usageCount: 'usageCount',
    begin: 'begin',
    end: 'end',
    organizationId: 'organizationId'
};
export const ApplicationMarketingMetadataScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    metadata: 'metadata',
    applicationId: 'applicationId'
};
export const ApplicationAnalyticsMetadataScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    sdkUpdateState: 'sdkUpdateState',
    topSDKVersion24h: 'topSDKVersion24h',
    topSDKVersion7d: 'topSDKVersion7d',
    latestSDKVersion7d: 'latestSDKVersion7d',
    releasesBehind: 'releasesBehind',
    onboardingSDKInstalled: 'onboardingSDKInstalled',
    onboardingSDKInstalledAt: 'onboardingSDKInstalledAt',
    onboardingPaywallPresented: 'onboardingPaywallPresented',
    onboardingPaywallPresentedAt: 'onboardingPaywallPresentedAt',
    onboardingTransactionCompleted: 'onboardingTransactionCompleted',
    onboardingTransactionCompletedAt: 'onboardingTransactionCompletedAt',
    onboardingProductsCreated: 'onboardingProductsCreated',
    onboardingProductsCreatedAt: 'onboardingProductsCreatedAt',
    onboardingProductsAddedToPaywall: 'onboardingProductsAddedToPaywall',
    onboardingProductsAddedToPaywallAt: 'onboardingProductsAddedToPaywallAt',
    onboardingCompleted: 'onboardingCompleted',
    onboardingCompletedAt: 'onboardingCompletedAt',
    onboardingProductionTransactionCompleted: 'onboardingProductionTransactionCompleted',
    onboardingProductionTransactionCompletedAt: 'onboardingProductionTransactionCompletedAt',
    transactions1d: 'transactions1d',
    transactions7d: 'transactions7d',
    transactionsPrevious7d: 'transactionsPrevious7d',
    transactionsPrevious7dDeltaAbsolute: 'transactionsPrevious7dDeltaAbsolute',
    transactionsPrevious7dDeltaPercentage: 'transactionsPrevious7dDeltaPercentage',
    transactions28d: 'transactions28d',
    applicationId: 'applicationId'
};
export const ApplicationUseageRecordScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    usageCount: 'usageCount',
    begin: 'begin',
    end: 'end',
    organizationUseageRecordId: 'organizationUseageRecordId',
    applicationId: 'applicationId'
};
export const OrganizationLocalizationTargetScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    organizationId: 'organizationId',
    locale: 'locale'
};
export const MembershipScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    role: 'role',
    organizationId: 'organizationId',
    userId: 'userId',
    invitedName: 'invitedName',
    invitedEmail: 'invitedEmail'
};
export const ApplicationScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    archivedAt: 'archivedAt',
    name: 'name',
    slug: 'slug',
    revenueCatPublicAPIKey: 'revenueCatPublicAPIKey',
    appStoreConnectSharedSecret: 'appStoreConnectSharedSecret',
    appId: 'appId',
    appleUrlScheme: 'appleUrlScheme',
    userAgentName: 'userAgentName',
    integrated: 'integrated',
    publicApiKey: 'publicApiKey',
    organizationId: 'organizationId',
    stripePrivateKey: 'stripePrivateKey',
    platform: 'platform',
    bundleId: 'bundleId',
    creatorId: 'creatorId',
    creatorEmail: 'creatorEmail',
    ignoreUsage: 'ignoreUsage',
    globallyDisabled: 'globallyDisabled',
    notificationRedirectUrl: 'notificationRedirectUrl',
    featuresEnabled: 'featuresEnabled',
    legacyPresentExperimentGroupId: 'legacyPresentExperimentGroupId',
    localizationProviderId: 'localizationProviderId',
    appleSmallBusinessStartDate: 'appleSmallBusinessStartDate',
    appleSmallBusinessEndDate: 'appleSmallBusinessEndDate',
    crmMetadata: 'crmMetadata'
};
export const ProjectScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    archivedAt: 'archivedAt',
    name: 'name',
    organizationId: 'organizationId'
};
export const ProjectApplicationScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    projectId: 'projectId',
    applicationId: 'applicationId',
    platform: 'platform'
};
export const GloballyEnabledFeatureScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    name: 'name'
};
export const ApplicationAuthenticationTokenScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    token: 'token',
    scopes: 'scopes',
    applicationId: 'applicationId'
};
export const IntegrationAuthenticationTokenScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    scope: 'scope',
    tokenPostfix: 'tokenPostfix',
    meta: 'meta'
};
export const ApplicationAsaConfigurationScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    clientId: 'clientId',
    teamId: 'teamId',
    keyId: 'keyId',
    publicKey: 'publicKey',
    privateKey: 'privateKey',
    applicationId: 'applicationId'
};
export const ApplicationAssConfigurationScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    bundleId: 'bundleId',
    keyId: 'keyId',
    issuerId: 'issuerId',
    privateKey: 'privateKey',
    applicationId: 'applicationId'
};
export const ApplicationAscConfigurationScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    keyId: 'keyId',
    issuerId: 'issuerId',
    privateKey: 'privateKey',
    applicationId: 'applicationId'
};
export const ApplicationGPAuthConfigurationScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    packageName: 'packageName',
    privateKey: 'privateKey',
    pubsubSubscriptionId: 'pubsubSubscriptionId',
    pubsubTopicName: 'pubsubTopicName',
    applicationId: 'applicationId'
};
export const ApplicationLiveStripeConfigurationScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    publishableKey: 'publishableKey',
    secretKey: 'secretKey',
    webhookId: 'webhookId',
    applicationId: 'applicationId'
};
export const ApplicationTestStripeConfigurationScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    publishableKey: 'publishableKey',
    secretKey: 'secretKey',
    webhookId: 'webhookId',
    applicationId: 'applicationId'
};
export const PaddleOAuthStateScalarFieldEnum = {
    id: 'id',
    state: 'state',
    applicationId: 'applicationId',
    environment: 'environment',
    userId: 'userId',
    createdAt: 'createdAt',
    expiresAt: 'expiresAt'
};
export const ApplicationLivePaddleOAuthConfigurationScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    accessToken: 'accessToken',
    refreshToken: 'refreshToken',
    tokenExpiresAt: 'tokenExpiresAt',
    scopes: 'scopes',
    hostedCheckoutUrl: 'hostedCheckoutUrl',
    webhookId: 'webhookId',
    applicationId: 'applicationId'
};
export const ApplicationTestPaddleOAuthConfigurationScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    accessToken: 'accessToken',
    refreshToken: 'refreshToken',
    tokenExpiresAt: 'tokenExpiresAt',
    scopes: 'scopes',
    hostedCheckoutUrl: 'hostedCheckoutUrl',
    webhookId: 'webhookId',
    applicationId: 'applicationId'
};
export const ApplicationSettingScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    key: 'key',
    value: 'value',
    applicationId: 'applicationId'
};
export const ApplicationWebhookDestinationScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    enabled: 'enabled',
    url: 'url',
    authorizationToken: 'authorizationToken',
    applicationId: 'applicationId'
};
export const ApplicationUserAttributeMappingScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    mapping: 'mapping',
    applicationId: 'applicationId'
};
export const ApplicationConfigCacheScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    productIdentifierGroups: 'productIdentifierGroups',
    enabledTriggerPaywalls: 'enabledTriggerPaywalls',
    enabledPaywalls: 'enabledPaywalls',
    eventNames: 'eventNames',
    applicationId: 'applicationId'
};
export const ShortLinkScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    url: 'url',
    slug: 'slug'
};
export const PaywallScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    archivedAt: 'archivedAt',
    migratedAt: 'migratedAt',
    inSuperwallWebflowAccount: 'inSuperwallWebflowAccount',
    name: 'name',
    slug: 'slug',
    url: 'url',
    substitutions: 'substitutions',
    requiredLocalizations: 'requiredLocalizations',
    pageStyles: 'pageStyles',
    manifest: 'manifest',
    products: 'products',
    ignoredLocalizations: 'ignoredLocalizations',
    primaryProductIdentifier: 'primaryProductIdentifier',
    secondaryProductIdentifier: 'secondaryProductIdentifier',
    tertiaryProductIdentifier: 'tertiaryProductIdentifier',
    presentationStyle: 'presentationStyle',
    presentationStyleV3: 'presentationStyleV3',
    backgroundColorHex: 'backgroundColorHex',
    darkBackgroundColorHex: 'darkBackgroundColorHex',
    showPaywallOption: 'showPaywallOption',
    paywallDismissal: 'paywallDismissal',
    presentationCondition: 'presentationCondition',
    applicationId: 'applicationId',
    enabled: 'enabled',
    templateJson: 'templateJson',
    localNotifications: 'localNotifications',
    featureGating: 'featureGating',
    onDeviceCache: 'onDeviceCache',
    isScrollEnabled: 'isScrollEnabled',
    reRouteBackButton: 'reRouteBackButton',
    gameControllerSupport: 'gameControllerSupport',
    introductoryOfferEligibility: 'introductoryOfferEligibility',
    webCheckoutDestination: 'webCheckoutDestination',
    localizationType: 'localizationType',
    templateType: 'templateType',
    templateCategories: 'templateCategories',
    templateId: 'templateId',
    sourcePaywallId: 'sourcePaywallId',
    surveyId: 'surveyId',
    v4: 'v4',
    deployedPaywallVersionId: 'deployedPaywallVersionId'
};
export const PaywallResourceRequirementScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    version: 'version',
    paywallResourceId: 'paywallResourceId',
    paywallId: 'paywallId'
};
export const PaywallVersionScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    version: 'version',
    editable: 'editable',
    title: 'title',
    description: 'description',
    paywallId: 'paywallId'
};
export const PaywallSnapshotScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    storageKey: 'storageKey',
    url: 'url',
    data: 'data',
    paywallVersionId: 'paywallVersionId'
};
export const PaywallResourcePaywallVersionRequirementScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    name: 'name',
    scope: 'scope',
    type: 'type',
    organizationId: 'organizationId',
    paywallVersionId: 'paywallVersionId'
};
export const PaywallResourcePaywallVersionVarintFixtureScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    name: 'name',
    scope: 'scope',
    type: 'type',
    organizationId: 'organizationId',
    paywallVersionId: 'paywallVersionId',
    variant: 'variant'
};
export const PaywallResourceScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    name: 'name',
    description: 'description',
    metadata: 'metadata',
    scope: 'scope',
    type: 'type',
    organizationId: 'organizationId'
};
export const TextPaywallResourceVersionRequirementScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    keyId: 'keyId',
    version: 'version',
    localizationProviderId: 'localizationProviderId',
    paywallSnapshotId: 'paywallSnapshotId',
    paywallVersionId: 'paywallVersionId'
};
export const TextPaywallResourceVersionVariantRequirementScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    keyId: 'keyId',
    version: 'version',
    variantVersion: 'variantVersion',
    variant: 'variant',
    localizationProviderId: 'localizationProviderId',
    paywallSnapshotId: 'paywallSnapshotId'
};
export const PaywallLanguageRequirementScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    language: 'language',
    paywallSnapshotId: 'paywallSnapshotId'
};
export const TextPaywallResourceScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    localizationProviderId: 'localizationProviderId',
    keyId: 'keyId',
    visibilitySince: 'visibilitySince',
    deletedAt: 'deletedAt'
};
export const TextPaywallResourceVersionScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    localizationProviderId: 'localizationProviderId',
    keyId: 'keyId',
    version: 'version',
    text: 'text',
    isDeleted: 'isDeleted'
};
export const TextPaywallResourceVersionVariantScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    localizationProviderId: 'localizationProviderId',
    keyId: 'keyId',
    version: 'version',
    variant: 'variant'
};
export const TextPaywallResourceVersionVariantVersionScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    localizationProviderId: 'localizationProviderId',
    keyId: 'keyId',
    version: 'version',
    variant: 'variant',
    variantVersion: 'variantVersion',
    text: 'text',
    status: 'status'
};
export const PaywallResourceVersionScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    version: 'version',
    releaseNotes: 'releaseNotes',
    snapshot: 'snapshot',
    storageKey: 'storageKey',
    previewUrl: 'previewUrl',
    paywallResourceId: 'paywallResourceId'
};
export const PaywallResourceVersionVariantScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    snapshot: 'snapshot',
    storageKey: 'storageKey',
    variant: 'variant',
    paywallResourceVersionId: 'paywallResourceVersionId'
};
export const PaywallSurveyScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    surveyId: 'surveyId',
    surveyPresentationCondition: 'surveyPresentationCondition',
    paywallId: 'paywallId'
};
export const PaywallPreviewScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    active: 'active',
    url: 'url',
    identifier: 'identifier',
    paywallId: 'paywallId',
    paywallResponse: 'paywallResponse'
};
export const PaywallLocalizationScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    locale: 'locale',
    substitutions: 'substitutions',
    paywallId: 'paywallId'
};
export const LocalizableStringScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    string: 'string',
    organizationId: 'organizationId'
};
export const PaywallLocalizableStringRequirementScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    localizableStringId: 'localizableStringId',
    paywallId: 'paywallId'
};
export const LocalizedStringScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    string: 'string',
    locale: 'locale',
    localizableStringId: 'localizableStringId'
};
export const PaywallTriggerScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    eventName: 'eventName',
    enabled: 'enabled',
    paywallId: 'paywallId',
    applicationId: 'applicationId',
    triggerExperimentGroupId: 'triggerExperimentGroupId'
};
export const WebPaywallTriggerScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    name: 'name',
    enabled: 'enabled',
    urlMatchingString: 'urlMatchingString',
    elementSelector: 'elementSelector',
    elementSelectorType: 'elementSelectorType',
    pageLoadDelayMs: 'pageLoadDelayMs',
    triggerType: 'triggerType',
    setupUrl: 'setupUrl',
    applicationId: 'applicationId',
    webPaywallId: 'webPaywallId'
};
export const WebPaywallScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    identifier: 'identifier',
    name: 'name',
    url: 'url',
    substitutions: 'substitutions',
    primaryProductId: 'primaryProductId',
    applicationId: 'applicationId'
};
export const WebProductScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    name: 'name',
    stripeProductId: 'stripeProductId',
    applicationId: 'applicationId',
    prices: 'prices'
};
export const StripeProductRankingScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    stripeProductId: 'stripeProductId',
    applicationId: 'applicationId',
    ranking: 'ranking'
};
export const TriggerExperimentGroupScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    description: 'description',
    notes: 'notes',
    applicationId: 'applicationId',
    isLegacyPresent: 'isLegacyPresent'
};
export const ApplicationUserScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    applicationId: 'applicationId',
    properties: 'properties',
    propertiesHash: 'propertiesHash',
    paywallId: 'paywallId',
    billableUser: 'billableUser',
    notificationNodeId: 'notificationNodeId',
    notificationNodeMergentTaskId: 'notificationNodeMergentTaskId',
    notificationNodeAssignedAt: 'notificationNodeAssignedAt'
};
export const ApplicationUserNotificationV2AssigmentScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    timelineCompletedAt: 'timelineCompletedAt',
    processLeaseEndAt: 'processLeaseEndAt',
    processId: 'processId',
    enteredAt: 'enteredAt',
    notificationNodeV2Id: 'notificationNodeV2Id',
    applicationUserId: 'applicationUserId'
};
export const ApplicationUserAliasScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    appUserId: 'appUserId',
    applicationUserId: 'applicationUserId',
    applicationId: 'applicationId'
};
export const ApplicationUserEventScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    eventName: 'eventName',
    eventParameters: 'eventParameters',
    applicationUserAliasId: 'applicationUserAliasId'
};
export const CustomerDomainScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    fqdn: 'fqdn',
    slug: 'slug',
    organizationId: 'organizationId'
};
export const StandardEventScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    name: 'name'
};
export const StorageBlobScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    bucket: 'bucket',
    key: 'key',
    filename: 'filename',
    metadata: 'metadata',
    organizationId: 'organizationId'
};
export const LocalizationFileUploadScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status',
    locale: 'locale',
    blobId: 'blobId',
    organizationId: 'organizationId'
};
export const NotificationTimelineScalarFieldEnum = {
    id: 'id',
    archivedAt: 'archivedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    applicationId: 'applicationId'
};
export const NotificationTimelineV2ScalarFieldEnum = {
    id: 'id',
    archivedAt: 'archivedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    notificationGraph: 'notificationGraph',
    applicationId: 'applicationId'
};
export const NotificationNodeV2ScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    notificationTimelineV2Id: 'notificationTimelineV2Id',
    delaySeconds: 'delaySeconds'
};
export const NotificationNodeScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    delaySeconds: 'delaySeconds',
    notificationTimelineId: 'notificationTimelineId',
    nextNodeId: 'nextNodeId'
};
export const NotificationPlanScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    planType: 'planType',
    planParameters: 'planParameters',
    sortOrder: 'sortOrder',
    notificationNodeId: 'notificationNodeId'
};
export const ProductScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    archivedAt: 'archivedAt',
    identifier: 'identifier',
    platform: 'platform',
    rawPrice: 'rawPrice',
    rawTrialPeriodPrice: 'rawTrialPeriodPrice',
    trialPeriodDays: 'trialPeriodDays',
    period: 'period',
    identifierRC: 'identifierRC',
    applicationId: 'applicationId'
};
export const ProductEntitlementsScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    productId: 'productId',
    entitlementId: 'entitlementId'
};
export const EntitlementScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    identifier: 'identifier',
    type: 'type',
    applicationId: 'applicationId'
};
export const LocalizedProductScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    locale: 'locale',
    language: 'language',
    region: 'region',
    currency: 'currency',
    productObjectHash: 'productObjectHash',
    productObject: 'productObject',
    productId: 'productId'
};
export const TriggerExperimentScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    expression: 'expression',
    expressionOccurrenceKey: 'expressionOccurrenceKey',
    useV2Editor: 'useV2Editor',
    ruleConditions: 'ruleConditions',
    interval: 'interval',
    occurrences: 'occurrences',
    rank: 'rank',
    description: 'description',
    enabled: 'enabled',
    experimentId: 'experimentId',
    triggerExperimentGroupId: 'triggerExperimentGroupId',
    variantOptimization: 'variantOptimization',
    templateType: 'templateType'
};
export const ExperimentScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    applicationId: 'applicationId'
};
export const VariantScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    foreignKey: 'foreignKey',
    foreignKeyType: 'foreignKeyType',
    variantType: 'variantType',
    percentage: 'percentage',
    experimentId: 'experimentId'
};
export const AssignmentScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAtUnix: 'deletedAtUnix',
    applicationUserId: 'applicationUserId',
    variantId: 'variantId',
    experimentId: 'experimentId',
    replicatedToClickhouse: 'replicatedToClickhouse'
};
export const PaywallAssetScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    applicationId: 'applicationId',
    key: 'key',
    name: 'name',
    attributes: 'attributes'
};
export const ApplicationETLDestinationScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    applicationId: 'applicationId',
    compression: 'compression',
    endpointUrl: 'endpointUrl',
    bucket: 'bucket',
    accessKeyId: 'accessKeyId',
    secretAccessKey: 'secretAccessKey'
};
export const SDKConfigurationToggleScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    applicationId: 'applicationId',
    key: 'key',
    enabled: 'enabled'
};
export const ApplicationSettingsScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    applicationId: 'applicationId',
    settings: 'settings'
};
export const ChatOpsSettingsScalarFieldEnum = {
    id: 'id',
    settings: 'settings'
};
export const PaywallTemplateScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    applicationId: 'applicationId',
    key: 'key',
    json: 'json'
};
export const SurveyScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    archivedAt: 'archivedAt',
    name: 'name',
    applicationId: 'applicationId',
    assignmentKey: 'assignmentKey',
    title: 'title',
    message: 'message',
    options: 'options',
    includeOtherOption: 'includeOtherOption',
    includeCloseOption: 'includeCloseOption',
    presentationProbability: 'presentationProbability'
};
export const StaffBarKVScalarFieldEnum = {
    key: 'key',
    value: 'value'
};
export const StorefrontCurrencyPriceInfoScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    storefront: 'storefront',
    currency: 'currency',
    customerPrice: 'customerPrice',
    proceeds: 'proceeds',
    proceedsYear2: 'proceedsYear2'
};
export const CurrencyExchangeRateScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    sourceCurrency: 'sourceCurrency',
    targetCurrency: 'targetCurrency',
    rate: 'rate'
};
export const SubscriptionEventScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    name: 'name',
    applicationId: 'applicationId',
    organizationId: 'organizationId',
    appUserId: 'appUserId',
    applicationUserId: 'applicationUserId',
    vendorId: 'vendorId',
    sdkVersion: 'sdkVersion',
    appVersion: 'appVersion',
    userProperties: 'userProperties',
    source: 'source',
    integration: 'integration',
    store: 'store',
    experimentId: 'experimentId',
    variantId: 'variantId',
    paywallId: 'paywallId',
    transactionCompleteEventDate: 'transactionCompleteEventDate',
    installDate: 'installDate',
    transactionId: 'transactionId',
    originalTransactionId: 'originalTransactionId',
    price: 'price',
    priceInPurchasedCurrency: 'priceInPurchasedCurrency',
    proceeds: 'proceeds',
    productId: 'productId',
    periodType: 'periodType',
    isTrialConversion: 'isTrialConversion',
    takehomePercentage: 'takehomePercentage',
    commissionPercentage: 'commissionPercentage',
    taxPercentage: 'taxPercentage',
    timestamp: 'timestamp',
    environment: 'environment',
    newProductId: 'newProductId',
    purchasedAt: 'purchasedAt',
    expirationAt: 'expirationAt',
    cancelReason: 'cancelReason',
    isFamilyShare: 'isFamilyShare',
    isSmallBusiness: 'isSmallBusiness',
    isRefund: 'isRefund',
    countryCode: 'countryCode',
    currencyCode: 'currencyCode',
    offerCode: 'offerCode',
    exchangeRate: 'exchangeRate',
    placement: 'placement',
    deploymentVersion: 'deploymentVersion'
};
export const OAuth2AuthorizationCodeScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    expiresAt: 'expiresAt',
    authorizationCode: 'authorizationCode',
    redirectUri: 'redirectUri',
    scope: 'scope',
    codeChallenge: 'codeChallenge',
    codeChallengeMethod: 'codeChallengeMethod',
    clientId: 'clientId',
    userId: 'userId'
};
export const OAuth2AccessTokenScalarFieldEnum = {
    id: 'id',
    accessToken: 'accessToken',
    accessTokenExpiresAt: 'accessTokenExpiresAt',
    scope: 'scope',
    clientId: 'clientId',
    userId: 'userId'
};
export const WebPaywallDomainScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    domain: 'domain',
    applicationId: 'applicationId'
};
export const AccountsAccountScalarFieldEnum = {
    id: 'id',
    accountId: 'accountId',
    providerId: 'providerId',
    userId: 'userId',
    accessToken: 'accessToken',
    refreshToken: 'refreshToken',
    idToken: 'idToken',
    accessTokenExpiresAt: 'accessTokenExpiresAt',
    refreshTokenExpiresAt: 'refreshTokenExpiresAt',
    scope: 'scope',
    password: 'password',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const AccountsJwksScalarFieldEnum = {
    id: 'id',
    publicKey: 'publicKey',
    privateKey: 'privateKey',
    createdAt: 'createdAt'
};
export const AccountsOauthAccessTokenScalarFieldEnum = {
    id: 'id',
    accessToken: 'accessToken',
    refreshToken: 'refreshToken',
    accessTokenExpiresAt: 'accessTokenExpiresAt',
    refreshTokenExpiresAt: 'refreshTokenExpiresAt',
    clientId: 'clientId',
    userId: 'userId',
    scopes: 'scopes',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const AccountsOauthApplicationScalarFieldEnum = {
    id: 'id',
    name: 'name',
    icon: 'icon',
    metadata: 'metadata',
    clientId: 'clientId',
    clientSecret: 'clientSecret',
    redirectUrls: 'redirectUrls',
    type: 'type',
    disabled: 'disabled',
    userId: 'userId',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const AccountsOauthConsentScalarFieldEnum = {
    id: 'id',
    clientId: 'clientId',
    userId: 'userId',
    scopes: 'scopes',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    consentGiven: 'consentGiven'
};
export const AccountsPasskeyScalarFieldEnum = {
    id: 'id',
    name: 'name',
    publicKey: 'publicKey',
    userId: 'userId',
    credentialId: 'credentialId',
    counter: 'counter',
    deviceType: 'deviceType',
    backedUp: 'backedUp',
    transports: 'transports',
    createdAt: 'createdAt',
    aaguid: 'aaguid'
};
export const AccountsSessionScalarFieldEnum = {
    id: 'id',
    expiresAt: 'expiresAt',
    token: 'token',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    ipAddress: 'ipAddress',
    userAgent: 'userAgent',
    userId: 'userId'
};
export const AccountsTwoFactorScalarFieldEnum = {
    id: 'id',
    secret: 'secret',
    backupCodes: 'backupCodes',
    userId: 'userId'
};
export const AccountsVerificationScalarFieldEnum = {
    id: 'id',
    identifier: 'identifier',
    value: 'value',
    expiresAt: 'expiresAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export const ApplicationIntegrationMetadataScalarFieldEnum = {
    id: 'id',
    applicationId: 'applicationId',
    endpointId: 'endpointId',
    integrationType: 'integrationType',
    integrationKey: 'integrationKey',
    displayName: 'displayName',
    endpointUrl: 'endpointUrl',
    enabled: 'enabled',
    eventsSubscribed: 'eventsSubscribed',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt'
};
export const UserViewScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    name: 'name',
    slug: 'slug',
    description: 'description',
    filters: 'filters',
    columns: 'columns',
    matchMode: 'matchMode',
    applicationId: 'applicationId',
    deletedAt: 'deletedAt'
};
export const Web2AppIntegrationScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    deletedAt: 'deletedAt',
    name: 'name',
    integrationId: 'integrationId',
    enabled: 'enabled',
    config: 'config',
    applicationId: 'applicationId'
};
export const IntegrationAccessRequestScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    integrationId: 'integrationId',
    integrationName: 'integrationName',
    userId: 'userId',
    applicationId: 'applicationId'
};
export const FigmaExportUploadScalarFieldEnum = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    importId: 'importId',
    version: 'version',
    exportedAt: 'exportedAt'
};
export const SortOrder = {
    asc: 'asc',
    desc: 'desc'
};
export const NullableJsonNullValueInput = {
    DbNull: 'DbNull',
    JsonNull: 'JsonNull'
};
export const JsonNullValueInput = {
    JsonNull: 'JsonNull'
};
export const JsonNullValueFilter = {
    DbNull: 'DbNull',
    JsonNull: 'JsonNull',
    AnyNull: 'AnyNull'
};
export const QueryMode = {
    default: 'default',
    insensitive: 'insensitive'
};
export const NullsOrder = {
    first: 'first',
    last: 'last'
};
export const UserOrderByRelevanceFieldEnum = {
    name: 'name',
    email: 'email',
    hashedPassword: 'hashedPassword',
    image: 'image'
};
export const BotUserOrderByRelevanceFieldEnum = {
    name: 'name',
    accessToken: 'accessToken'
};
export const SessionOrderByRelevanceFieldEnum = {
    handle: 'handle',
    hashedSessionToken: 'hashedSessionToken',
    antiCSRFToken: 'antiCSRFToken',
    publicData: 'publicData',
    privateData: 'privateData'
};
export const TokenOrderByRelevanceFieldEnum = {
    hashedToken: 'hashedToken',
    sentTo: 'sentTo'
};
export const MembershipTokenOrderByRelevanceFieldEnum = {
    hashedToken: 'hashedToken',
    sentTo: 'sentTo'
};
export const OrganizationOrderByRelevanceFieldEnum = {
    name: 'name',
    stripeCustomer: 'stripeCustomer',
    stripeSubscription: 'stripeSubscription'
};
export const OrganizationSubscriptionOrderByRelevanceFieldEnum = {
    stripeSubscriptionId: 'stripeSubscriptionId',
    stripeCustomerId: 'stripeCustomerId'
};
export const LocalizationProviderOrderByRelevanceFieldEnum = {
    type: 'type',
    projectIdentifier: 'projectIdentifier',
    projectDisplayName: 'projectDisplayName',
    sourceLanguageLocale: 'sourceLanguageLocale',
    sourceLanguageDisplayName: 'sourceLanguageDisplayName',
    sourceLanguageProviderLanguageId: 'sourceLanguageProviderLanguageId'
};
export const LocalizationProviderSyncOrderByRelevanceFieldEnum = {
    message: 'message'
};
export const LocalizationProviderFilePathOrderByRelevanceFieldEnum = {
    filePath: 'filePath'
};
export const LocalizationProviderKeyNameOrderByRelevanceFieldEnum = {
    keyName: 'keyName'
};
export const SWLocalization_ProjectOrderByRelevanceFieldEnum = {
    projectIdentifier: 'projectIdentifier'
};
export const SWLocalization_ProjectLanguageOrderByRelevanceFieldEnum = {
    locale: 'locale',
    projectIdentifier: 'projectIdentifier'
};
export const SWLocalization_KeyOrderByRelevanceFieldEnum = {
    key: 'key',
    baseText: 'baseText',
    projectIdentifier: 'projectIdentifier'
};
export const SWLocalization_KeyTranslationOrderByRelevanceFieldEnum = {
    translation: 'translation',
    locale: 'locale',
    projectIdentifier: 'projectIdentifier'
};
export const SuperwallLocalizationProviderOrderByRelevanceFieldEnum = {
    projectIdentifier: 'projectIdentifier'
};
export const ApplicationAnalyticsMetadataOrderByRelevanceFieldEnum = {
    sdkUpdateState: 'sdkUpdateState',
    topSDKVersion24h: 'topSDKVersion24h',
    topSDKVersion7d: 'topSDKVersion7d',
    latestSDKVersion7d: 'latestSDKVersion7d'
};
export const OrganizationLocalizationTargetOrderByRelevanceFieldEnum = {
    locale: 'locale'
};
export const MembershipOrderByRelevanceFieldEnum = {
    invitedName: 'invitedName',
    invitedEmail: 'invitedEmail'
};
export const ApplicationOrderByRelevanceFieldEnum = {
    name: 'name',
    slug: 'slug',
    revenueCatPublicAPIKey: 'revenueCatPublicAPIKey',
    appStoreConnectSharedSecret: 'appStoreConnectSharedSecret',
    appId: 'appId',
    appleUrlScheme: 'appleUrlScheme',
    userAgentName: 'userAgentName',
    publicApiKey: 'publicApiKey',
    stripePrivateKey: 'stripePrivateKey',
    bundleId: 'bundleId',
    creatorEmail: 'creatorEmail',
    notificationRedirectUrl: 'notificationRedirectUrl',
    featuresEnabled: 'featuresEnabled'
};
export const ProjectOrderByRelevanceFieldEnum = {
    name: 'name'
};
export const GloballyEnabledFeatureOrderByRelevanceFieldEnum = {
    name: 'name'
};
export const ApplicationAuthenticationTokenOrderByRelevanceFieldEnum = {
    token: 'token'
};
export const IntegrationAuthenticationTokenOrderByRelevanceFieldEnum = {
    scope: 'scope',
    tokenPostfix: 'tokenPostfix'
};
export const ApplicationAsaConfigurationOrderByRelevanceFieldEnum = {
    clientId: 'clientId',
    teamId: 'teamId',
    keyId: 'keyId',
    publicKey: 'publicKey',
    privateKey: 'privateKey'
};
export const ApplicationAssConfigurationOrderByRelevanceFieldEnum = {
    bundleId: 'bundleId',
    keyId: 'keyId',
    issuerId: 'issuerId',
    privateKey: 'privateKey'
};
export const ApplicationAscConfigurationOrderByRelevanceFieldEnum = {
    keyId: 'keyId',
    issuerId: 'issuerId',
    privateKey: 'privateKey'
};
export const ApplicationGPAuthConfigurationOrderByRelevanceFieldEnum = {
    packageName: 'packageName',
    privateKey: 'privateKey',
    pubsubSubscriptionId: 'pubsubSubscriptionId',
    pubsubTopicName: 'pubsubTopicName'
};
export const ApplicationLiveStripeConfigurationOrderByRelevanceFieldEnum = {
    publishableKey: 'publishableKey',
    secretKey: 'secretKey',
    webhookId: 'webhookId'
};
export const ApplicationTestStripeConfigurationOrderByRelevanceFieldEnum = {
    publishableKey: 'publishableKey',
    secretKey: 'secretKey',
    webhookId: 'webhookId'
};
export const PaddleOAuthStateOrderByRelevanceFieldEnum = {
    state: 'state'
};
export const ApplicationLivePaddleOAuthConfigurationOrderByRelevanceFieldEnum = {
    accessToken: 'accessToken',
    refreshToken: 'refreshToken',
    scopes: 'scopes',
    hostedCheckoutUrl: 'hostedCheckoutUrl',
    webhookId: 'webhookId'
};
export const ApplicationTestPaddleOAuthConfigurationOrderByRelevanceFieldEnum = {
    accessToken: 'accessToken',
    refreshToken: 'refreshToken',
    scopes: 'scopes',
    hostedCheckoutUrl: 'hostedCheckoutUrl',
    webhookId: 'webhookId'
};
export const ApplicationSettingOrderByRelevanceFieldEnum = {
    key: 'key'
};
export const ApplicationWebhookDestinationOrderByRelevanceFieldEnum = {
    url: 'url',
    authorizationToken: 'authorizationToken'
};
export const ShortLinkOrderByRelevanceFieldEnum = {
    url: 'url',
    slug: 'slug'
};
export const PaywallOrderByRelevanceFieldEnum = {
    name: 'name',
    slug: 'slug',
    url: 'url',
    primaryProductIdentifier: 'primaryProductIdentifier',
    secondaryProductIdentifier: 'secondaryProductIdentifier',
    tertiaryProductIdentifier: 'tertiaryProductIdentifier',
    backgroundColorHex: 'backgroundColorHex',
    darkBackgroundColorHex: 'darkBackgroundColorHex',
    templateId: 'templateId'
};
export const PaywallVersionOrderByRelevanceFieldEnum = {
    title: 'title',
    description: 'description'
};
export const PaywallSnapshotOrderByRelevanceFieldEnum = {
    storageKey: 'storageKey',
    url: 'url'
};
export const PaywallResourcePaywallVersionRequirementOrderByRelevanceFieldEnum = {
    name: 'name',
    type: 'type'
};
export const PaywallResourcePaywallVersionVarintFixtureOrderByRelevanceFieldEnum = {
    name: 'name',
    type: 'type',
    variant: 'variant'
};
export const PaywallResourceOrderByRelevanceFieldEnum = {
    name: 'name',
    description: 'description',
    type: 'type'
};
export const TextPaywallResourceVersionVariantRequirementOrderByRelevanceFieldEnum = {
    variant: 'variant'
};
export const PaywallLanguageRequirementOrderByRelevanceFieldEnum = {
    language: 'language'
};
export const TextPaywallResourceVersionOrderByRelevanceFieldEnum = {
    text: 'text'
};
export const TextPaywallResourceVersionVariantOrderByRelevanceFieldEnum = {
    variant: 'variant'
};
export const TextPaywallResourceVersionVariantVersionOrderByRelevanceFieldEnum = {
    variant: 'variant',
    text: 'text'
};
export const PaywallResourceVersionOrderByRelevanceFieldEnum = {
    releaseNotes: 'releaseNotes',
    storageKey: 'storageKey',
    previewUrl: 'previewUrl'
};
export const PaywallResourceVersionVariantOrderByRelevanceFieldEnum = {
    storageKey: 'storageKey',
    variant: 'variant'
};
export const PaywallPreviewOrderByRelevanceFieldEnum = {
    url: 'url',
    identifier: 'identifier'
};
export const PaywallLocalizationOrderByRelevanceFieldEnum = {
    locale: 'locale'
};
export const LocalizableStringOrderByRelevanceFieldEnum = {
    string: 'string'
};
export const LocalizedStringOrderByRelevanceFieldEnum = {
    string: 'string',
    locale: 'locale'
};
export const PaywallTriggerOrderByRelevanceFieldEnum = {
    eventName: 'eventName'
};
export const WebPaywallTriggerOrderByRelevanceFieldEnum = {
    name: 'name',
    urlMatchingString: 'urlMatchingString',
    elementSelector: 'elementSelector',
    setupUrl: 'setupUrl'
};
export const WebPaywallOrderByRelevanceFieldEnum = {
    identifier: 'identifier',
    name: 'name',
    url: 'url'
};
export const WebProductOrderByRelevanceFieldEnum = {
    name: 'name',
    stripeProductId: 'stripeProductId'
};
export const StripeProductRankingOrderByRelevanceFieldEnum = {
    stripeProductId: 'stripeProductId'
};
export const TriggerExperimentGroupOrderByRelevanceFieldEnum = {
    description: 'description',
    notes: 'notes'
};
export const ApplicationUserOrderByRelevanceFieldEnum = {
    propertiesHash: 'propertiesHash',
    notificationNodeMergentTaskId: 'notificationNodeMergentTaskId'
};
export const ApplicationUserNotificationV2AssigmentOrderByRelevanceFieldEnum = {
    processId: 'processId'
};
export const ApplicationUserAliasOrderByRelevanceFieldEnum = {
    appUserId: 'appUserId'
};
export const CustomerDomainOrderByRelevanceFieldEnum = {
    fqdn: 'fqdn',
    slug: 'slug'
};
export const StandardEventOrderByRelevanceFieldEnum = {
    name: 'name'
};
export const StorageBlobOrderByRelevanceFieldEnum = {
    bucket: 'bucket',
    key: 'key',
    filename: 'filename'
};
export const LocalizationFileUploadOrderByRelevanceFieldEnum = {
    locale: 'locale'
};
export const ProductOrderByRelevanceFieldEnum = {
    identifier: 'identifier',
    period: 'period',
    identifierRC: 'identifierRC'
};
export const EntitlementOrderByRelevanceFieldEnum = {
    identifier: 'identifier'
};
export const LocalizedProductOrderByRelevanceFieldEnum = {
    locale: 'locale',
    language: 'language',
    region: 'region',
    currency: 'currency',
    productObjectHash: 'productObjectHash'
};
export const TriggerExperimentOrderByRelevanceFieldEnum = {
    expression: 'expression',
    expressionOccurrenceKey: 'expressionOccurrenceKey',
    rank: 'rank',
    description: 'description'
};
export const PaywallAssetOrderByRelevanceFieldEnum = {
    key: 'key',
    name: 'name'
};
export const ApplicationETLDestinationOrderByRelevanceFieldEnum = {
    endpointUrl: 'endpointUrl',
    bucket: 'bucket',
    accessKeyId: 'accessKeyId',
    secretAccessKey: 'secretAccessKey'
};
export const SDKConfigurationToggleOrderByRelevanceFieldEnum = {
    key: 'key'
};
export const PaywallTemplateOrderByRelevanceFieldEnum = {
    key: 'key'
};
export const SurveyOrderByRelevanceFieldEnum = {
    name: 'name',
    assignmentKey: 'assignmentKey',
    title: 'title',
    message: 'message'
};
export const StaffBarKVOrderByRelevanceFieldEnum = {
    key: 'key',
    value: 'value'
};
export const StorefrontCurrencyPriceInfoOrderByRelevanceFieldEnum = {
    storefront: 'storefront',
    currency: 'currency'
};
export const CurrencyExchangeRateOrderByRelevanceFieldEnum = {
    sourceCurrency: 'sourceCurrency',
    targetCurrency: 'targetCurrency'
};
export const SubscriptionEventOrderByRelevanceFieldEnum = {
    id: 'id',
    name: 'name',
    appUserId: 'appUserId',
    vendorId: 'vendorId',
    sdkVersion: 'sdkVersion',
    appVersion: 'appVersion',
    source: 'source',
    integration: 'integration',
    transactionId: 'transactionId',
    originalTransactionId: 'originalTransactionId',
    productId: 'productId',
    newProductId: 'newProductId',
    countryCode: 'countryCode',
    currencyCode: 'currencyCode',
    offerCode: 'offerCode',
    placement: 'placement'
};
export const OAuth2AuthorizationCodeOrderByRelevanceFieldEnum = {
    authorizationCode: 'authorizationCode',
    redirectUri: 'redirectUri',
    scope: 'scope',
    codeChallenge: 'codeChallenge',
    codeChallengeMethod: 'codeChallengeMethod',
    clientId: 'clientId'
};
export const OAuth2AccessTokenOrderByRelevanceFieldEnum = {
    accessToken: 'accessToken',
    scope: 'scope',
    clientId: 'clientId'
};
export const WebPaywallDomainOrderByRelevanceFieldEnum = {
    domain: 'domain'
};
export const AccountsAccountOrderByRelevanceFieldEnum = {
    accountId: 'accountId',
    providerId: 'providerId',
    accessToken: 'accessToken',
    refreshToken: 'refreshToken',
    idToken: 'idToken',
    scope: 'scope',
    password: 'password'
};
export const AccountsJwksOrderByRelevanceFieldEnum = {
    publicKey: 'publicKey',
    privateKey: 'privateKey'
};
export const AccountsOauthAccessTokenOrderByRelevanceFieldEnum = {
    accessToken: 'accessToken',
    refreshToken: 'refreshToken',
    clientId: 'clientId',
    userId: 'userId',
    scopes: 'scopes'
};
export const AccountsOauthApplicationOrderByRelevanceFieldEnum = {
    name: 'name',
    icon: 'icon',
    metadata: 'metadata',
    clientId: 'clientId',
    clientSecret: 'clientSecret',
    redirectUrls: 'redirectUrls',
    type: 'type',
    userId: 'userId'
};
export const AccountsOauthConsentOrderByRelevanceFieldEnum = {
    clientId: 'clientId',
    userId: 'userId',
    scopes: 'scopes'
};
export const AccountsPasskeyOrderByRelevanceFieldEnum = {
    name: 'name',
    publicKey: 'publicKey',
    credentialId: 'credentialId',
    deviceType: 'deviceType',
    transports: 'transports',
    aaguid: 'aaguid'
};
export const AccountsSessionOrderByRelevanceFieldEnum = {
    token: 'token',
    ipAddress: 'ipAddress',
    userAgent: 'userAgent'
};
export const AccountsTwoFactorOrderByRelevanceFieldEnum = {
    secret: 'secret',
    backupCodes: 'backupCodes'
};
export const AccountsVerificationOrderByRelevanceFieldEnum = {
    identifier: 'identifier',
    value: 'value'
};
export const ApplicationIntegrationMetadataOrderByRelevanceFieldEnum = {
    endpointId: 'endpointId',
    integrationKey: 'integrationKey',
    displayName: 'displayName',
    endpointUrl: 'endpointUrl'
};
export const UserViewOrderByRelevanceFieldEnum = {
    name: 'name',
    slug: 'slug',
    description: 'description',
    matchMode: 'matchMode'
};
export const Web2AppIntegrationOrderByRelevanceFieldEnum = {
    name: 'name',
    integrationId: 'integrationId'
};
export const IntegrationAccessRequestOrderByRelevanceFieldEnum = {
    integrationId: 'integrationId',
    integrationName: 'integrationName'
};
export const FigmaExportUploadOrderByRelevanceFieldEnum = {
    importId: 'importId',
    version: 'version',
    exportedAt: 'exportedAt'
};
